import React from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";

import Header from "./components/pageSectionComponents/header.js";
import Footer from "./components/pageSectionComponents/footer.js";
import ScrollToTop from "./components/scrollComponents/ScrollToTop"; // adjust path if needed

import AboutPage from "./components/pageComponents/AboutPage/about-us.js";
import ContactPage from "./components/pageComponents/ContactPage/contact.js";
import FaqPage from "./components/pageComponents/FaqPage/faq.js";
import HomePage from "./components/pageComponents/HomePage/homepage.js";
import MilestonePage from "./components/pageComponents/PastworkPage/milestones.js";
import ServicePage from "./components/pageComponents/ServicePage/services.js";
import TrainingPage from "./components/pageComponents/TrainingPage/training.js";

function App() {
  return (
    <div className="min-h-screen bg-[#e6f4ea]">
      <Router>
        <Header />
        
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/milestones" element={<MilestonePage />} />
            <Route path="/services" element={<ServicePage />} />
            <Route path="/trainings" element={<TrainingPage />} />
          </Routes>
        </main>
        <Footer />
        <ScrollToTop />
      </Router>
    </div>
  );
}

export default App;
